import { collectionsReportsAxios } from '../config/axiosInstances';
import { FindPendingInterfacesRequest, FindPendingInterfacesResponse } from './SalesApi';

export interface FindReliefsRequest {
  countryAcronym: string;
  storeAcronym?: string;
  businessDateRange?: string;
  groupBy?: string;
}

export type FindReliefsResponse = {
  country: string;
  store?: string;
  business_date?: string;
  quantity: number;
  amount: number;
}[];

export interface FindPettyCashDifferenceRequest {
  countryAcronym: string;
  storeAcronym?: string;
  businessDateRange?: string;
  differenceType?: string;
  sentToOnedrive: boolean;
}

export type FindPettyCashDifferenceBaseResponse = {
  country: string;
  store: string;
  transfer_id: number;
  transfer_type_id: string;
  business_date: string;
  operation_date: string;
  transfer_time?: string;
  pos_num: number;
  shift_num: number;
  user_id: number;
  username: string;
  employee_id: number;
  employee_name: string;
  total_amt: number;
};

export type FindPettyCashDifferenceResponse = FindPettyCashDifferenceBaseResponse[];

export type FindPettyCashDifferenceByPaymentTypeRequest = FindPettyCashDifferenceRequest & {
  tenderName?: string;
};

export type FindPettyCashDifferenceByPaymentTypeResponse = (FindPettyCashDifferenceBaseResponse & {
  tender_name: string;
  amount: number;
  foreign_amount: number;
  fc_rate: number;
})[];

export interface FindEconomicAccountingReportRequest {
  countryAcronym: string;
  storeAcronym?: string;
  businessDateRange?: string;
  payment_type_ids?: string;
  only_diff: boolean;
  franchiseType?: string;
  groupBy?: string;
  sentToOnedrive: boolean;
}

export interface FindCashMovementReportRequest {
  countryAcronym: string;
  storeAcronym?: string;
  businessDateRange?: string;
  payment_type_ids?: string;
  movements_type?: string;
  sentToOnedrive: boolean;
}

export type FindEconomicAccountingReportResponse = {
  country: string;
  store: string;
  franchise_type: string;
  business_date: string;
  tender_description: string;
  tender_name: string;
  gross_sales: number;
  cashier_difference: number;
  excess: number;
  tips: number;
  petty_cash_extraction: number;
  recaudado: string;
  saldo_teorico_reca: number;
  saldo_teorico_conv_reca: number;
  extracash: number;
  diferencia: number;
  cuenta: number;
  subcuenta: number;
  reprocessed: string;
  comment: string;
}[];

export type FindCashMovementReportResponse = {
  pais: string;
  local: string;
  Fecha_de_Negocio: string;
  Nro_Referencia: number;
  Nro_Movimiento: number;
  Moneda: string;
  Tipo_Movimiento: string;
  Hora_Movimiento: string;
  Id_Usuario: string;
  Nombre_Usuario: string;
  Codigo_Movimiento: string;
  Smartcash: string;
  Smartcash_Manual: string;
  Deposito_Teorico: number;
  Donacion: number;
  Recupero: number;
  Extracion_Caja_Chica: number;
  Compra_Cambio: number;
  Arqueo_Caja: number;
  Extracash: number;
  Diferencia_Arqueo: number;
  witness_emp_id: string;
  witness_emp_name: string;
}[];

export interface FindAccounitngInformationReportRequest {
  countryAcronym: string;
  storeAcronym?: string;
  businessDateRange?: string;
  sentToOnedrive: boolean;
}

export type FindPettyCashWithdrawalReportResponse = {
  pais: string;
  local: string;
  mes: string;
  agreement_type: string;
  tender_wh: number;
  tender_name: string;
  extraccion_caja: number;
}[];

export interface FindExtraCashReportRequest {
  countryAcronym: string;
  storeAcronym?: string;
  businessDateRange?: string;
  franchiseType?: string;
  sentToOnedrive: boolean;
}

export type FindExtraCashReportResponse = {
  pais: string;
  local: string;
  mes: string;
  agreement_type: string;
  tender_wh: number;
  tender_name: string;
  extra_cash: number;
}[];

export type FindCashCountReportResponse = {
  pais: string;
  local: string;
  mes: string;
  agreement_type: string;
  tender_wh: number;
  tender_name: string;
  Diferencia_Arqueo: number;
  counted: number;
  expected: number;
}[];

export type FindRecoveryReportResponse = {
  pais: string;
  local: string;
  mes: string;
  agreement_type: string;
  tender_wh: number;
  tender_name: string;
  recupero: number;
}[];

export type FindExchangePurchaseReportResponse = {
  pais: string;
  local: string;
  mes: string;
  agreement_type: string;
  tender_wh: number;
  tender_name: string;
  compra_cambio: number;
}[];

export type FindFixedFundReportResponse = {
  pais: string;
  local: string;
  mes: string;
  agreement_type: string;
  tender_wh: number;
  tender_name: string;
  tipo: string;
  cuenta: string;
  dr: number;
  cr: number;
}[];

export type FindCashDiscrepancyReportResponse = {
  pais: string;
  local: string;
  mes: string;
  agreement_type: string;
  tender_name: string;
  cuenta: string;
  entered_dr: number;
  entered_cr: number;
  accounted_dr: number;
  accounted_cr: number;
  exceso: number;
}[];
export interface FindEnvelopeDetailsReportRequest {
  countryAcronym: string;
  storeAcronym?: string;
  businessDateRange?: string;
  envelope_code?: string;
}

export type FindEnvelopeDetailsReportResponse = {
  pais: string;
  local: string;
  fecha_de_negocio: string;
  pos: string;
  sobre: string;
  tipo_movimiento: string;
  nro_referencia: number;
  nro_movimiento: number;
  id_moneda: string;
  moneda: string;
  hora_movimiento: string;
  shift_num: number;
  employee_id: string;
  employee_name: string;
  id_usuario: string;
  nombre_usuario: string;
  monto_del_movimiento: number;
}[];

export default class {
  static async findReliefs(request: FindReliefsRequest) {
    return collectionsReportsAxios.get<FindReliefsResponse>(`/reliefs`, {
      params: request,
    });
  }

  static async findPettyCashDifference(request: FindPettyCashDifferenceRequest) {
    return collectionsReportsAxios.get<FindPettyCashDifferenceResponse>(`/petty_cash_difference`, {
      params: request,
    });
  }

  static async findPettyCashDifferenceByPaymentType(
    request: FindPettyCashDifferenceByPaymentTypeRequest
  ) {
    return collectionsReportsAxios.get<FindPettyCashDifferenceByPaymentTypeResponse>(
      `/petty_cash_difference_by_payment_type`,
      {
        params: request,
      }
    );
  }

  static async findPendingInterface(request: FindPendingInterfacesRequest) {
    return collectionsReportsAxios.get<FindPendingInterfacesResponse>(`/pending_interfaces`, {
      params: request,
    });
  }

  static async findEconomicAccountigReport(request: FindEconomicAccountingReportRequest) {
    return collectionsReportsAxios.get<FindEconomicAccountingReportResponse>(
      `/report_economic_contable`,
      {
        params: request,
      }
    );
  }

  static async findPettyCashWithdrawalReport(request: FindAccounitngInformationReportRequest) {
    return collectionsReportsAxios.get<FindPettyCashWithdrawalReportResponse>(
      `/petty_cash_accounting_info`,
      {
        params: request,
      }
    );
  }

  static async findExtraCashReport(request: FindExtraCashReportRequest) {
    return collectionsReportsAxios.get<FindExtraCashReportResponse>(`/extra_cash_accounting_info`, {
      params: request,
    });
  }

  static async findCashMovementReport(request: FindCashMovementReportRequest) {
    return collectionsReportsAxios.get<FindCashMovementReportResponse>(`/report_cash_movements`, {
      params: request,
    });
  }

  static async findCashCountReport(request: FindAccounitngInformationReportRequest) {
    return collectionsReportsAxios.get<FindCashCountReportResponse>(
      `/reconciliation_difference_accounting_info`,
      {
        params: request,
      }
    );
  }

  static async findRecoveryReport(request: FindAccounitngInformationReportRequest) {
    return collectionsReportsAxios.get<FindRecoveryReportResponse>(
      `/change_recovery_accounting_info`,
      {
        params: request,
      }
    );
  }

  static async findExchangePurchaseReport(request: FindAccounitngInformationReportRequest) {
    return collectionsReportsAxios.get<FindExchangePurchaseReportResponse>(
      `/purchase_exchange_accounting_info`,
      {
        params: request,
      }
    );
  }

  static async findFixedFundReport(request: FindAccounitngInformationReportRequest) {
    return collectionsReportsAxios.get<FindFixedFundReportResponse>(`/fixed_fund_accounting_info`, {
      params: request,
    });
  }

  static async findCashDiscrepancyReport(request: FindAccounitngInformationReportRequest) {
    return collectionsReportsAxios.get<FindCashDiscrepancyReportResponse>(
      `/cashier_difference_accounting_info`,
      {
        params: request,
      }
    );
  }

  static async findEnvelopeDetailsReport(request: FindEnvelopeDetailsReportRequest) {
    return collectionsReportsAxios.get<FindEnvelopeDetailsReportResponse>(`/detail_envelopes`, {
      params: request,
    });
  }
}
